import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const browseConversationsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtualagent-browseconversations',
	exact: true,
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations',
};
